export default "__VITE_ASSET__vnFeB$kL__"